import { render, staticRenderFns } from "./EditNotificationPopup.vue?vue&type=template&id=7d22ebf4&scoped=true"
import script from "./EditNotificationPopup.vue?vue&type=script&lang=js"
export * from "./EditNotificationPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d22ebf4",
  null
  
)

export default component.exports